var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.overlayData.component,{directives:[{name:"show",rawName:"v-show",value:(_vm.overlayVisible()),expression:"overlayVisible()"}],tag:"div",attrs:{"id":"game_overlay_view"}})}
var staticRenderFns = []

export { render, staticRenderFns }